/* ============================================================
   Mobile sticky add-to-cart bar.
   Shown when the main product CTA scrolls out of view.
   ============================================================ */
(function () {
  'use strict';

  const sticky = document.querySelector('[data-zc-sticky-cta]');
  const target = document.querySelector('[data-zc-product-cta]');
  if (!sticky || !target) return;

  // No IO support → keep the bar visible.
  if (typeof IntersectionObserver === 'undefined') {
    sticky.classList.add('is-visible');
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      });
    },
    { threshold: 0, rootMargin: '0px 0px -120px 0px' }
  );

  io.observe(target);

  // Forward clicks on the sticky button to the main form.
  const stickyBtn = sticky.querySelector('[data-zc-sticky-submit]');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', (event) => {
      event.preventDefault();
      const form = target.closest('form');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  }
})();
